
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post125() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Pessoal com diabetes tipo 1. Quais os legumes vocês mais usam no dia a dia?</title>
        <meta 
          name="description" 
          content="Pessoal com diabetes tipo 1. Quais os legumes vocês mais usam no dia a dia?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Paula Farber &#183; 18/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Pessoal com diabetes tipo 1. Quais os legumes vocês mais usam no dia a dia?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/125')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi, Paula!<br/>Que bom que você está buscando trocar experiências sobre alimentação! Legumes são ótimos para controlar a diabetes e manter uma dieta saudável. Olha, alguns dos legumes que muitas pessoas com diabetes tipo 1 costumam usar são:<br/><br/>1. **Brócolis** - Rico em fibras e nutrientes.<br/>2. **Abobrinha** - Versátil e baixo em carboidratos.<br/>3. **Couve-flor** - Pode substituir o arroz ou a massa em várias receitas.<br/>4. **Espinafre** - Uma ótima fonte de vitaminas e minerais.<br/>5. **Pepino** - Ótimo para saladas e super refrescante.<br/><br/>Lembrando sempre de consultar seu médico ou nutricionista antes de fazer mudanças na dieta. Eles podem te ajudar a escolher legumes que são melhores para você. 😊<br/><br/>Boa sorte e continue firme no controle da diabetes!<br/><br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 18/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/125')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marlene Techini &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/48-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, tenho 31 anos e não fumo.<br/>Descobri que estou com com câncer de pulmão e estou assustada.<br/>Alguém com câncer no pulmão poderia compartilhar como está sendo?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/48')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Paula Farber &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/94-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Alguém com diabetes, que tem fezes moles e diarréia constante?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/94')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marília Dornelles &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/87-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia pessoal. Estou com diabetes gestacional. Como posso abaixar a diabetes através da alimentação?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/87')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Manuela Escobar &#183; 23/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/148-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom tarde<br/>Gostaria de tirar uma dúvida, caneta pra medir glicemia pode ser usada várias vezes?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/148')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/11-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes: Minha experiência medindo glicose em casa  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Após o diagnóstico com diabetes, a melhor coisa que fiz foi comprar um medidor de glicose, aprender a usar e medir todos os dias. Recomendo para todos sempre. Acredito que esse seja o melhor jeito para aprender a controlar a diabetes.<br/><br/>Dica: para mim, o melhor lugar para espetar o dedo é nos lados das pontas, perto das unhas (mas não muito perto).<br/><br/>Teste sua glicose com a maior frequência que você conseguir: Isso é especialmente importante no início, quando você está aprendendo como seu corpo reage às diferentes comidas e os exercícios físicos que você faz.<br/><br/>A maioria das pessoas gosta de medir quando levantam de manhã. Isso é chamado de teste de jejum, e dá uma indicação de quão bom foi o seu controle no dia anterior.<br/><br/>Outros horários comuns para testar:<br/><br/>1) Uma ou duas horas depois de uma refeição: o resultado mostra quão alto a sua glicose sobre quando você come aquelas comidas em particular. Toda a comida que você põe na boca influencia o nível de glicose, e é importante entender como é essa influência.<br/><br/>2) Antes da próxima refeição: o resultado mostra se a subida da glicose da refeição anterior já desceu para o patamar normal antes da próxima refeição.<br/><br/>3) Antes e depois de exercício.<br/><br/>4) Na hora de dormir.<br/><br/>5) A qualquer momento que você acha que tem algo de errado.<br/><br/>É legal rotacionar os horários de teste ao longo dos dias para conseguir mais informações.<br/><br/>Após mais ou menos um ano com esse treinamento intensivo, eu tinha um bom conhecimento de como meu corpo reagia as várias coisas, e pude reduzir a frequência das medições.<br/><br/>Por fim, registre e guarde os resultados das medições (no caderno, no computador ou no excel, onde você quiser), e também tenha cópia de todos os seus exames. Ter esses registros vai fazer com que você estude mais para entendê-los e vai te ajudar a saber como está a sua condição ao longo do tempo. No longo prazo, esse registros valem ouro!<br/><br/>Espero que isso possa ajudar quem está começando sua jornada com diabetes!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/11')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
